import React, { useState, useCallback } from 'react';

// Components
import WpAlert from '../WpAlert';
import WpIcon from '../../icon/WpIcon';

const AlertsDocs = () => {
  const [isShowing, setIsShowing] = useState(true);
  const types = ['note', 'info', 'success', 'warning', 'danger', 'strong'] as const;

  const onDismissClick = useCallback(() => {
    setIsShowing(false);
  }, []);

  return (
    <>
      {types.map(type => (
        <div className="mb-2">
          <WpAlert key={type} type={type}>
            {type}
          </WpAlert>
        </div>
      ))}
      <h5 className="mt-5">hide the icon</h5>
      <WpAlert type="note" showIcon={false}>
        no icon in alert
      </WpAlert>
      <h5 className="mt-5">With custom icon</h5>
      <WpAlert type="success" icon={<WpIcon name="cog" />}>
        Custom Icon
      </WpAlert>
      <h5 className="mt-5">Dissmissable</h5>
      {isShowing && (
        <WpAlert type="info" onDismiss={onDismissClick}>
          Dismiss me
        </WpAlert>
      )}
    </>
  );
};

export default AlertsDocs;
